import React from 'react';
import './Hackathon.css';
import { FaGithub, FaTrophy, FaUsers, FaMedal } from 'react-icons/fa';
import levelSupermindCert from '../images/levelsupermind_cert.png';
import visualBuildersPhoto from '../images/visualbuilders_photo.png';

const Hackathon: React.FC = () => {
  return (
    <div className="hackathon-container">
      <h2 className="hackathon-title">🏆 Hackathon Achievements</h2>
      <p className="hackathon-intro">Showcasing my competitive programming and rapid prototyping skills</p>

      <div className="hackathon-content">
        {/* LevelSuperMind Hackathon */}
        <div className="hackathon-item">
          <div className="hackathon-image-container">
            <img src={levelSupermindCert} alt="LevelSuperMind Hackathon Certificate" className="hackathon-image" />
          </div>
          <div className="hackathon-details">
            <h3 className="hackathon-event-title">
              <FaTrophy className="trophy-icon" /> LevelSuperMind 2025 - 2nd Runner Up
            </h3>
            <p className="hackathon-date">Competition Scale: 25,000+ Teams</p>
            <p className="hackathon-description">
              Competed against 25,000 teams and advanced to the final round with 800 participants.
              Secured 2nd Runner Up position with an innovative astrology-based application.
            </p>
            <div className="hackathon-achievements">
              <h4>Project: SoulBuddy</h4>
              <p>An astrology-based platform that provides personalized insights and guidance.</p>
              <ul>
                <li><FaUsers /> Advanced to finals from 25,000+ teams</li>
                <li><FaMedal /> 2nd Runner Up among 800 finalists</li>
                <li>🌟 Innovative use of AI for personalized astrology</li>
                <li>🚀 Built with modern tech stack and scalable architecture</li>
              </ul>
              <a
                href="https://github.com/Vink-135/SoulBuddy"
                target="_blank"
                rel="noopener noreferrer"
                className="github-link"
              >
                <FaGithub /> View Project on GitHub
              </a>
            </div>
          </div>
        </div>

        {/* Visual Builders Hackathon */}
        <div className="hackathon-item">
          <div className="hackathon-image-container">
            <img src={visualBuildersPhoto} alt="Visual Builders Hackathon Event" className="hackathon-image" />
          </div>
          <div className="hackathon-details">
            <h3 className="hackathon-event-title">
              <FaTrophy className="trophy-icon" /> Visual Builders - 2nd Place
            </h3>
            <p className="hackathon-description">
              Secured 2nd place by developing LawMate, a platform that connects users with lawyers
              for legal consultation and assistance.
            </p>
            <div className="hackathon-achievements">
              <h4>Project: LawMate</h4>
              <p>A comprehensive platform connecting users with legal professionals for consultations and assistance.</p>
              <ul>
                <li><FaMedal /> 2nd Place Winner</li>
                <li>⚖️ Streamlined lawyer-client connection process</li>
                <li>💼 User-friendly interface for legal consultations</li>
                <li>🔒 Secure and confidential communication system</li>
              </ul>
              <a
                href="https://github.com/Vink-135/Visual_Builders_Project"
                target="_blank"
                rel="noopener noreferrer"
                className="github-link"
              >
                <FaGithub /> View Project on GitHub
              </a>
            </div>
          </div>
        </div>

        <div className="hackathon-skills">
          <h3>Skills Demonstrated</h3>
          <div className="skills-tags">
            <span className="skill-tag">Rapid Prototyping</span>
            <span className="skill-tag">Team Collaboration</span>
            <span className="skill-tag">Time Management</span>
            <span className="skill-tag">Problem Solving</span>
            <span className="skill-tag">AI/ML Implementation</span>
            <span className="skill-tag">Full-Stack Development</span>
            <span className="skill-tag">UI/UX Design</span>
            <span className="skill-tag">Scalable Architecture</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hackathon;